import React from 'react';
import { motion } from 'framer-motion'

const AnimatedModel = ({Children}) => {
    return (
        <motion.div
            layout
            transition={{
                opacity: { ease: "linear" },
                layout: { duration: 0.5 }
            }}
      
        >
            {Children}
        </motion.div>
    );
}

export default AnimatedModel;
